import { createMuiTheme } from '@material-ui/core';

export default createMuiTheme({
  palette: {
    primary: {
      light: '#CE4257',
      main: '#720026',
      dark: '#4F000B',
    },
    secondary: {
      main: '#FF7F51',
    },
    text: {
      primary: '#000',
      secondary: '#CE4257',
    },
  },
  typography: {
    fontSize: 12,
  },
});
